<div
  *ngIf="page.isPreview() && !subscriptionsParams.apiUrl"
  class="no-document"
>
  <div edsGrid class="no-document__component">
    <div class="no-document__overlay">
      Click to configure <strong>Subscriptions Manage Component</strong>
    </div>
  </div>
</div>

<div edsRow *ngIf="subscriptionsParams.frequency">
  <!-- Radio Group -->
  <ng-container>
    <div edsSpacing="lg">
      <eds-radio-group (radioChange)="onRadioChange($event)" name="frequency">
        <div class="radio">{{ "subscriptions.frequency" | translate }}</div>
        <eds-radio
          *ngFor="let radio of radioItems"
          [id]="radio.id"
          [value]="radio"
          labelName="{{ 'subscriptions.frequency-' + radio.id | translate }}"
        >
        </eds-radio>
      </eds-radio-group>
    </div>
  </ng-container>
</div>
<ng-container *ngIf="subscriptionsParams?.sectionType === 'products'">
  <ft-subscriptions-products
    [apiUrl]="subscriptionsParams.apiUrl"
  ></ft-subscriptions-products>
</ng-container>

<ng-container *ngIf="subscriptionsParams?.sectionType === 'products-v2'">
  <ft-subscriptions-products-ii
    [apiUrl]="subscriptionsParams.apiUrl"
  ></ft-subscriptions-products-ii>
</ng-container>
